<template>
    <table class="table">
        <thead>
            <tr>
                <th width="20%"><small>Disponible en inventario</small></th>
                <th width="40%"><small>Ubicaciones</small></th>
                <th width="40%"><small>Campos personalizados</small></th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td class="text-center">{{ data.in_use ? 'SI' : 'NO' }}</td>
                <td>
                    <div v-if="data.locations.length > 0">
                        <ul class="m-0 py-0 pl-3">
                            <li v-for="location of data.locations" :key="location.id"><small>{{
                                location.name }}</small></li>
                        </ul>
                    </div>
                    <div v-else>
                        <small class="text-warning">No hay registros de ubicaciones</small>
                    </div>
                </td>
                <td>
                    <div v-if="data.custom_fields.length > 0">
                        <b-row v-for="customField of data.custom_fields" :key="customField.id">
                            <b-col sm="12" md="6"><small><b>{{ customField.name }}:</b></small></b-col>
                            <b-col sm="12" md="6"><small>{{ customField.value }}</small></b-col>
                            <b-col cols="12">
                                <hr class="m-0">
                            </b-col>
                        </b-row>
                    </div>
                    <div v-else>
                        <small class="text-warning">No hay registros de campos personalizados</small>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
</template>
<script>
export default {
    name: 'ItemListDetailsChanges',

    props: {
        data: {
            type: Object,
            required: true,
            default: () => {
                return {
                    in_use: false,
                    locations: [],
                    custom_fields: []
                }
            }
        }
    },
}
</script>

<style scoped></style>